<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.masqueBloc.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeFacture')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeFacture }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeBail')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeContrat }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeEmplacement')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeEmplacement }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeDispositif')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeDispositif }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeMateriel')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeMateriel }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeFace')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeFace }}
            </span>
          </b-field>
        </div>
        <div class="column is-3" v-if="modulePresseActive">
          <b-field :label="$t('detailSociete.masqueBloc.masqueCodeParution')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueCodeParution }}
            </span>
          </b-field>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueLibelleUnitaireNonPatrimonial')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueLibelleProduitUnitaireNonPatrimonial }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueLibelleUnitairePatrimonial')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueLibelleProduitUnitairePatrimonial }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueLibelleEcranNumNonPatrimonial')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueLibelleProduitEcranNumeriqueNonPatrimonial }}
            </span>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('detailSociete.masqueBloc.masqueLibelleEcranNumPatrimonial')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ societe.masqueLibelleProduitEcranNumeriquePatrimonial }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'SocieteDetailMasque',
  props: {
    societe: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
